var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6793 12.5093C21.6849 12.6399 21.6886 12.7706 21.6886 12.9031C21.6886 16.9219 18.6288 21.557 13.0338 21.557C11.3158 21.557 9.71732 21.0538 8.37091 20.1911C8.60905 20.2189 8.85091 20.2328 9.09647 20.2328C10.5216 20.2328 11.8328 19.7473 12.8744 18.9309C11.5428 18.9068 10.4197 18.0274 10.0324 16.8191C10.2186 16.8543 10.4086 16.8728 10.605 16.8728C10.8821 16.8728 11.1508 16.8357 11.4066 16.7662C10.0148 16.4873 8.96674 15.2577 8.96674 13.7843V13.7454C9.37631 13.9733 9.84612 14.1105 10.3447 14.1262C9.52828 13.5805 8.99083 12.6492 8.99083 11.5947C8.99083 11.0368 9.14095 10.5142 9.40319 10.0648C10.9034 11.9051 13.145 13.1162 15.6728 13.2432C15.621 13.0208 15.5941 12.7882 15.5941 12.55C15.5941 10.87 16.9563 9.50786 18.6353 9.50786C19.511 9.50786 20.3014 9.87759 20.8556 10.4688C21.5487 10.3326 22.2001 10.0796 22.7876 9.73118C22.5606 10.441 22.0778 11.0368 21.4505 11.414C22.0658 11.3398 22.6514 11.1767 23.1972 10.9349C22.7895 11.5446 22.2733 12.0802 21.6793 12.5093ZM15.784 0.706604C7.59531 0.706604 0.957764 7.34415 0.957764 15.5329C0.957764 23.7207 7.59531 30.3592 15.784 30.3592C23.9728 30.3592 30.6103 23.7207 30.6103 15.5329C30.6103 7.34415 23.9728 0.706604 15.784 0.706604Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cc55621a7a64cf5373fea4da683de7bd.svg";
export { ForwardRef as ReactComponent };